import React, { useState } from 'preact/compat';
import AnimateHeight from 'react-animate-height';

import SearchBar from './SearchBar';
import SearchResults from './SearchResults';

export default function Search(props) {
    const defaultState = {
        searchText: '',
        results: [],
        showResults: false,
    };

    const [state, setState] = useState(defaultState);

    const clearSearch = () => {
        // clears all search related state attributes -> results are no longer displayed
        setState(defaultState);
    };

    const handleHeightAnimationEnd = () => {
        // clear the search results if the search just closed
        if (!state.showResults) {
            clearSearch();
        }
    };

    const handleSearchTextChange = (searchText) => {
        if (searchText.length > 2) {
            // search input text using the search function Api.search()
            // using this.flyoutApi.activeObject as anchor and set state accordingly

            const results = props.api.search(searchText);

            setState({
                searchText,
                results,
                showResults: true,
            });
        } else {
            setState((prevState) => (
                { ...prevState, showResults: false }
            ));
        }
    };

    const handleKeyPress = (e) => {
        // resets the search on Escape click while focusing something in the search (results)
        if (e.key === 'Escape') {
            clearSearch();
            e.stopPropagation();
        }
    };

    const results = (
        <SearchResults
            results={state.results}
            numRes={state.results.length}
            text={state.searchText}
        />
    );

    return (
        <>
            <div className={`search-mask${state.showResults ? ' active' : ''}`} />
            <div className="search">
                <div className="search-bar">
                    <SearchBar
                        onSearchTextChange={handleSearchTextChange}
                        clearSearch={clearSearch}
                    />
                </div>
                <AnimateHeight
                    className="search-results"
                    aria-live="polite"
                    height={state.showResults ? 'auto' : 0}
                    duration={300}
                    applyInlineTransitions={false}
                    onHeightAnimationEnd={handleHeightAnimationEnd}
                    onKeyDown={handleKeyPress}
                >
                    { state.searchText && results }
                </AnimateHeight>
            </div>
        </>
    );
}
